// extracted by mini-css-extract-plugin
export default {"card":"ConditionCard_card__dh78r"};